import { render, staticRenderFns } from "./CompleteYourRegistration.vue?vue&type=template&id=4bc9c406"
import script from "./CompleteYourRegistration.vue?vue&type=script&lang=js"
export * from "./CompleteYourRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports